export const en = {
  learnMore: 'Learn more',
  sidebarVersion: 'Sidebar version',
  whichVersion:
    'Select which version of the BugHerd sidebar to display for this project.',
  newMessage: `BugHerd for the modern web. Mobile first, clean & simple UI. Use the shortcut (Ctrl + Cmd + B for Mac or Ctrl + Alt + B for a Windows device) to reveal the BugHerd sidebar.`,
  newHeader: 'NEW',
  legacyMessage: 'The original BugHerd sidebar experience.',
  legacyHeader: 'LEGACY',
  publicFeedbackHeader: 'Public Feedback',
  publicFeedbackMessage: `Show the public "Send Feedback" tab on your website, when users aren't logged into BugHerd.`,
  shortcutHeader: 'Shortcut',
  shorcutMessage:
    'Create your own shortcut to show the BugHerd sidebar (default is Ctrl + Cmd + B or Ctrl + Alt + B for Windows users).',
  verticalPositionHeader: 'Vertical Position',
  verticalPositionMessage:
    'How far the BugHerd tab sits from the top of your website.',
  save: 'Save',
  cancel: 'Cancel',
  updateSuccess: 'Successfully updated settings',
  acceptingFeedbackHeader: 'Accepting client feedback',
  acceptingFeedbackMessage:
    'Enable or pause new feedback from clients on this project.',
  acceptingFeedbackHint: 'Members can still leave feedback.',
  feedbackDateModalTitle: 'Set a Feedback Deadline',
  feedbackDateModalMessage:
    'Schedule a time and date to pause any new client feedback coming in',
  schedule: 'Schedule',
  scheduleTimeAndDate: 'Schedule a time and date to pause new client feedback',
  disableFeedbackCollection: 'Pause now',
  scheduledDate: 'Feedback collection controlled by the scheduled date',
  enableDisable: 'Enable/Disable client feedback',
  acceptingFeedbackUntil: 'Accepting client feedback until ',
  editSchedule: 'Edit',
  removeScedule: 'Remove',
  feedbackCollectionExpired: 'Client feedback collection period expired on ',
  enabled: 'Currently accepting client feedback',
  paused: 'Client feedback paused',
  upgrade: 'Upgrade',
  clientFeedbackHeader: 'Client Feedback',
  clientFeedbackMessage: (firstProjectColumnName: string) =>
    `Send new Client Feedback directly to ${firstProjectColumnName}.`
};

export type Translations = typeof en;
